"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckoutController = void 0;
var _i18n = require("@ori/i18n");
var _logger = require("@ori/logger");
var _presentationHttp = require("@ori/presentation-http");
var _shoppingContext = require("@ori/shopping-context");
var _testidGenerator = require("@ori/testid-generator");
var _react = require("react");
var _Checkout = require("../components/Checkout");
var _constants = require("../constants");
var _contexts = require("../contexts");
var _logger2 = require("../logger");
var _ApiProvider = require("./ApiProvider");
var _NavigationContextProvider = require("./NavigationContextProvider");
var _jsxRuntime = require("react/jsx-runtime");
const CheckoutController = ({
  configuration
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_testidGenerator.TestIdProvider, {
  project: _constants.PACKAGE_NAME,
  team: _testidGenerator.Team.Checkout,
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
    fallback: null,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.LoggerProvider, {
      logger: _logger2.mainLogger,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
        areaName: "CheckoutController",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ApiProvider.ApiProvider, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationHttp.UserSegmentationDataProvider, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_shoppingContext.ShoppingContextProvider, {
              eventNames: ['update-offer-item', 'update-offer-items'],
              parentComponentName: _constants.APP_NAME,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.CheckoutProvider, {
                configuration: configuration,
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
                  namespace: _constants.translationsNamespace,
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_NavigationContextProvider.NavigationContextProvider, {
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Checkout.Checkout, {})
                  })
                })
              })
            })
          })
        })
      })
    })
  })
});
exports.CheckoutController = CheckoutController;